import * as t from "io-ts"
import { cast, maybe, Maybe } from "@flockcover/flock-svc-core-types"
import { UUID } from "io-ts-types/lib/UUID"

const FilterVehicleType = t.type({
  id: UUID,
  make: t.string,
  model: t.string,
  trim: maybe(t.string),
  fuelType: t.string,
  nominalStartYear: maybe(t.number),
  abiCode: maybe(t.string),
  abiGroup: maybe(t.number),
  numberOfSeats: maybe(t.number),
  type: t.string,
  grossWeight: maybe(t.number),
})

const FilterVehiclesResponseType = t.type({
  manufacturers: t.readonlyArray(t.string),
  models: t.readonlyArray(t.string),
  fuelTypes: t.readonlyArray(t.string),
  vehicles: t.readonlyArray(FilterVehicleType),
})

export type Variables = {
  make?: Maybe<string>
  model?: Maybe<string>
  fuelType?: Maybe<string>
}

export const makeFilterVehicle = cast(FilterVehicleType)
export const makeFilterVehiclesResponse = cast(FilterVehiclesResponseType)
export type FilterVehiclesResponse = t.TypeOf<typeof FilterVehiclesResponseType>
export type FilterVehicle = t.TypeOf<typeof FilterVehicleType>
